import React, { useRef } from 'react'

import { useBulletinBody } from '../../hooks/useBulletinBody/useBulletinBody'
import { SanitizedHtml } from '../../../SanitizedHtml/SanitizedHtml'
import { BulletinType } from '../../../../../common/validations'

interface BulletinBodyProps {
  body: string
  language?: BulletinType['language']
}

export const BulletinBody: React.FC<BulletinBodyProps> = ({
  body,
  language,
}) => {
  const ref = useRef<HTMLDivElement>(null)
  const html = useBulletinBody(body, ref)

  return (
    <div ref={ref} lang={language}>
      <SanitizedHtml html={html} />
    </div>
  )
}
